import React from 'react'
import { X } from 'lucide-react'
import { ExampleList } from './ExampleList'

interface ClothingGuideModalProps {
  isOpen: boolean
  onClose: () => void
}

export const ClothingGuideModal: React.FC<ClothingGuideModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-[20px] border-2 border-[#00B7B9] shadow-2xl p-8 max-w-[730px] w-full mx-4">
        {/* 헤더 */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[#2E343D] text-base font-bold w-[436px]">
            💃🏻 옷 잘 입히는 노하우! 꼭 체크해주세요.
          </h2>
          <button
            onClick={onClose}
            className="w-6 h-6 flex items-center justify-center hover:bg-gray-100 rounded transition-colors"
          >
            <X size={16} className="text-black" />
          </button>
        </div>

        {/* 가이드 텍스트 */}
        <div className="mb-6">
          <p className="text-[#2E343D] text-base leading-6">
            👕 옷의 전체가 잘 보이는 상·하의 구분이 명확하고, 소매·칼라·밑단 등 옷의 형태가 모두 드러나는 이미지.
            <br />
            📸 이미지가 너무 작거나 화질이 낮으면 생성이 어렵습니다
            <br />
            🌈 배경은 단순할수록 좋아요
            <br />
            📷 촬영 각도는 정면이 더 안정적인 결과를 줍니다.
            <br />
            ✂️ 손, 액세서리, 가방 등이 옷과 겹치는 등 불필요한 요소는 최소화하세요
          </p>
        </div>

        {/* 예시 이미지들 */}
        <div className="w-[666px]">
          <ExampleList width="w-[130px]" height="h-[130px]" showBadge={true} />
        </div>
      </div>
    </div>
  )
}